const { handleError, handleResponse, api } = require("./baseApi");
const api_config = require("./api_config");

const EXTEND_URL = "/customers/users/v1";

function customerUserApi(email, includeLoginMethods) {
  const includeLoginMethodsParam = (includeLoginMethods != null) ? ("&includeLoginMethods=" + !!includeLoginMethods) : "";
  const encodedEmail = encodeURIComponent(email);
  return api
    .get(`${EXTEND_URL}?email=${encodedEmail}${includeLoginMethodsParam}`, {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
    })
    .then(handleResponse)
    .catch(handleError);
}

function updateUserApi(email, updateLastSignedInAt) {
  const encodedEmail = encodeURIComponent(email);
    return api
      .patch(`${EXTEND_URL}?email=${encodedEmail}`, JSON.stringify({ updateLastSignedInAt}), {
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
        })
        .then(handleResponse)
        .catch(handleError);
}

module.exports = { customerUserApi, updateUserApi };
